// extracted by mini-css-extract-plugin
export default {"transitionSpeed":"250ms","toggleButton":"QtX6GZEac5TfuA5wPtBQ","on":"h4P0nhVS2HnotHr_rxSg"};